import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/logoHome.png'
import _imports_1 from '../../../assets/images/user/loginicon.png'


const _withScopeId = n => (_pushScopeId("data-v-3aa03490"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sk-auth" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sk-auth__bg",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sk-auth__noise",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_4 = { class: "sk-shell" }
const _hoisted_5 = {
  class: "sk-left",
  "aria-label": "Presentación de Skola"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"sk-left__overlay\" aria-hidden=\"true\" data-v-3aa03490></div><div class=\"sk-left__pattern\" aria-hidden=\"true\" data-v-3aa03490></div><div class=\"sk-left__content\" data-v-3aa03490><div class=\"sk-left__brand\" data-v-3aa03490><img src=\"" + _imports_0 + "\" class=\"sk-left__logo\" alt=\"Skola\" data-v-3aa03490><span class=\"sk-left__badge\" data-v-3aa03490>Plataforma de gestión académica</span></div><h1 class=\"sk-left__title\" data-v-3aa03490> Libera tu tiempo.<br data-v-3aa03490><span data-v-3aa03490>Potencia tu escuela.</span></h1><p class=\"sk-left__text\" data-v-3aa03490>Gestión inteligente, aprendizaje sin límites.</p><div class=\"sk-left__pillrow\" aria-hidden=\"true\" data-v-3aa03490><span class=\"sk-pill\" data-v-3aa03490>Claridad</span><span class=\"sk-pill\" data-v-3aa03490>Adaptabilidad</span><span class=\"sk-pill\" data-v-3aa03490>Innovación</span></div></div>", 3)
const _hoisted_10 = { class: "sk-right" }
const _hoisted_11 = {
  class: "sk-card",
  role: "region",
  "aria-label": "Inicio de sesión"
}
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<header class=\"sk-head\" data-v-3aa03490><div class=\"sk-head__top\" data-v-3aa03490><div class=\"sk-head__mark\" data-v-3aa03490><span class=\"sk-dot\" aria-hidden=\"true\" data-v-3aa03490></span><span class=\"sk-head__product\" data-v-3aa03490>Skola</span></div><small class=\"sk-head__hint\" data-v-3aa03490>Acceso seguro</small></div><div class=\"sk-head__main\" data-v-3aa03490><div class=\"sk-head__icon\" data-v-3aa03490><img src=\"" + _imports_1 + "\" alt=\"User\" data-v-3aa03490></div><div class=\"sk-head__txt\" data-v-3aa03490><h2 data-v-3aa03490>Bienvenido</h2><p data-v-3aa03490>Accede a tu entorno educativo</p></div></div></header>", 1)
const _hoisted_13 = { class: "sk-field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Usuario / correo electrónico", -1))
const _hoisted_15 = { class: "sk-control" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sk-control__icon",
  "aria-hidden": "true"
}, "👤", -1))
const _hoisted_17 = { class: "sk-field" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Contraseña", -1))
const _hoisted_19 = { class: "sk-control" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sk-control__icon",
  "aria-hidden": "true"
}, "🔒", -1))
const _hoisted_21 = { class: "sk-row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm me-2" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sk-foot" }, [
  /*#__PURE__*/_createElementVNode("small", null, "Skola · Plataforma de gestión académica")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("aside", _hoisted_5, [
        _createVNode(_component_Swiper, {
          modules: _ctx.modules,
          "slides-per-view": 1,
          loop: true,
          autoplay: _ctx.autoplay,
          pagination: _ctx.pagination,
          class: "sk-left__swiper"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (img, idx) => {
              return (_openBlock(), _createBlock(_component_SwiperSlide, { key: idx }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: img,
                    class: "sk-left__img",
                    alt: "Skola"
                  }, null, 8, _hoisted_6)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["modules", "autoplay", "pagination"]),
        _hoisted_7
      ]),
      _createElementVNode("main", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_b_form, {
            onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"]),
            class: "sk-form"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.Email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.record.Email) = $event)),
                    type: "text",
                    placeholder: "Ingrese su usuario o correo",
                    class: "sk-input",
                    required: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.Password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.record.Password) = $event)),
                    type: "password",
                    placeholder: "Ingrese su contraseña",
                    class: "sk-input",
                    required: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_router_link, {
                  to: "/forgot-password",
                  class: "sk-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" ¿Olvidó su contraseña? ")
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_b_button, {
                type: "submit",
                class: "sk-btn",
                disabled: _ctx.form.loading
              }, {
                default: _withCtx(() => [
                  (_ctx.form.loading)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_22,
                        _createTextVNode(" Cargando... ")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("INICIAR SESIÓN")
                      ], 64))
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["onSubmit"]),
          _hoisted_23
        ])
      ])
    ])
  ]))
}